import purchaseOrderService from "../../../../services/procurementService/purchaseOrderService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERS } from "../../../../utils/constants";
import { PurchaseOrderInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrder";
import ToastMessage from "../../../../common/ToastMessage";

interface AddPurchateOrderContext {
  previousPurchaseOrders: PurchaseOrderInterface[];
}

const useAddPurchaseOrder = (
  page: number,
  pageSize: number,
  fileNames: {
    fileUrl: string;
    fileName: string;
  }[]
) => {
  const queryClient = useQueryClient();

  return useMutation<
    PurchaseOrderInterface,
    Error,
    PurchaseOrderInterface,
    AddPurchateOrderContext
  >({
    mutationFn: (item) => purchaseOrderService.Create(item, fileNames),

    onMutate: () => {
      const previousPurchaseOrders =
        queryClient.getQueryData<PurchaseOrderInterface[]>([
          CACHE_KEY_PURCHASEORDERS,
          page,
          pageSize,
        ]) || [];

      return { previousPurchaseOrders };
    },

    onSuccess: (savedPurchaseOrder) => {
      ToastMessage.Success();
      queryClient.setQueryData<PurchaseOrderInterface[]>(
        [CACHE_KEY_PURCHASEORDERS, page, pageSize],
        (purchaseOrders) =>
          purchaseOrders
            ? [savedPurchaseOrder, ...purchaseOrders]
            : [savedPurchaseOrder]
      );
    },

    onError: (error, newPurchaseOrder, context) => {
      ToastMessage.Failed();
      if (!context) return;

      queryClient.setQueryData<PurchaseOrderInterface[]>(
        [CACHE_KEY_PURCHASEORDERS, page, pageSize],
        context.previousPurchaseOrders
      );
    },
  });
};

export default useAddPurchaseOrder;
